import axios from "axios";

import { auth } from "@Firebase/firebase";
import { FeedbackData } from "@Pages/HelpCenter/Feedback/Feedback";

export const sendFeedback = (): ((data: FeedbackData) => Promise<object>) => {
  return async (data) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/feedback/`,
      data,
      {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.result;
  };
};
